"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=price-list.dto.js.map